module.exports = __webpack_public_path__ + "static/FakedesOutline-b6c16a055ccc3aacabbad72a2330fe91.woff2";